// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DH-z","hovered":"EH-z","hoverImage":"FH-z","mainImage":"GH-z","imageNoBackground":"HH-z","fullSizeImage":"IH-z"};